const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key];
  if (value === undefined || value === null) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error(`Missing environment variable: ${key}`);
  }
  return String(value);
};

const getBoolEnvVar = (key: string, defaultValue: boolean): boolean => {
  const value = import.meta.env[key];
  if (value === undefined) {
    return defaultValue;
  }
  return value === 'true' || value === '1';
};

// An empty base url is the deployed case: the service is served from the app's own origin
const getBaseUrlEnvVar = (key: string, defaultValue: string): string => {
  const value = getEnvVar(key, defaultValue);
  return value === '' ? window.location.origin : value;
};

const apiBaseUrl = getBaseUrlEnvVar('VITE_API_BASE_URL', 'http://localhost:8080');

// The notification service (notifyd) runs on its own origin and serves /v1/inbox directly off this base
const notificationApiBaseUrl = getBaseUrlEnvVar(
  'VITE_NOTIFICATION_API_BASE_URL',
  ''
);

export const env = {
  apiBaseUrl: apiBaseUrl + "/api",
  authBaseUrl: apiBaseUrl + "/do",
  notificationApiBaseUrl,
  enableLogging: getBoolEnvVar('VITE_ENABLE_LOGGING', true),
  appTitle: getEnvVar('VITE_APP_TITLE', 'Eurodima'),
  defaultTheme: getEnvVar('VITE_DEFAULT_THEME', 'eurodima') as
    | 'eurodima'
    | 'tyrolit',
  defaultMode: getEnvVar('VITE_DEFAULT_MODE', 'light') as 'light' | 'dark',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

export type Env = typeof env;
